import {
  FormGroup,
  Grid,
  MenuItem,
  TextField,
  Typography,
  Autocomplete,
} from '@mui/material';
import React from 'react';
import NumberFormat from 'react-number-format';
import { Link, useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { POND_STATUS_CYCLE } from 'utils/consts';

function CycleInfo(props) {
  const {
    formik, ponds, setSelectedPond, selectedPond, id,
  } = props;
  const history = useHistory();
  const notIsFirstAccess = useSelector(
    (state) => state.notIsFirstAccess.notIsFirstAccess,
  );

  return (
    <Grid item xs={12}>
      <Typography
        style={{
          fontWeight: '700',
          fontSize: '32px',
          textAlign: 'left',
          marginTop: '-2rem',
          position: 'absolute',
        }}
      >
        Dados do viveiro por ciclo
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <FormGroup style={{ width: '100%', marginTop: '5rem', position: 'relative' }}>
            <Autocomplete
              noOptionsText={(
                <Typography>
                  A propriedade não possui nenhum viveiro cadastrado neste ciclo .
                  <Link
                    style={{ marginLeft: '1%', cursor: 'pointer' }}
                    color="primary"
                    onMouseDown={() => {
                      history.push(
                        notIsFirstAccess ? '/first-pond' : '/pond',
                      );
                    }}
                  >
                    Cadastrar Viveiro +
                  </Link>
                </Typography>
                )}
              id="pond"
              name="pond"
              options={ponds}
              value={selectedPond}
              getOptionLabel={(options) => options.description}
              onChange={(_p, v) => {
                setSelectedPond(v);
                formik.values.pond = v?.id;
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Viveiro"
                  variant="outlined"
                  onBlur={formik.handleBlur}
                  error={formik.touched.pond && formik.errors.pond}
                  helperText={formik.touched.pond && formik.errors.pond}
                />
              )}
            />
          </FormGroup>
        </Grid>
        <Grid item xs={12}>
          <FormGroup>
            <NumberFormat
              InputLabelProps={{ style: { pointerEvents: 'auto' } }}
              id="density"
              fullWidth
              label="Densidade (animais/m²)"
              variant="outlined"
              name="density"
              thousandSeparator="."
              decimalSeparator=","
              decimalScale={0}
              value={formik.values.density}
              onValueChange={(values) => {
                formik.setValues({
                  ...formik.values,
                  density: values.floatValue,
                });
              }}
              onBlur={formik.handleBlur}
              customInput={TextField}
              error={formik.touched.density && formik.errors.density}
              helperText={formik.touched.density && formik.errors.density}
            />
          </FormGroup>
        </Grid>

        {/* <Grid item xs={12}>
            <FormGroup>
              <NumberFormat
                disabled
                InputLabelProps={{ style: { pointerEvents: "auto" } }}
                id="population"
                fullWidth
                label="População atual (quantidade de animais)"
                variant="outlined"
                name="population"
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={0}
                value={formik.values.population}
                onValueChange={(values) => {
                  formik.setValues({
                    ...formik.values,
                    population: values.floatValue,
                  });
                }}
                onBlur={formik.handleBlur}
                customInput={TextField}
                error={formik.touched.population && formik.errors.population}
                helperText={
                  formik.touched.population && formik.errors.population
                }
              />
            </FormGroup>
          </Grid> */}

        {id != null && (
        <Grid item xs={12}>
          <FormGroup>
            <TextField
              InputLabelProps={{ style: { pointerEvents: 'auto' } }}
              id="status"
              select
              label="Status do ciclo"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              variant="outlined"
              value={formik.values.status}
              name="status"
                  // as="select"
              error={formik.touched.status && formik.errors.status}
              helperText={formik.touched.status && formik.errors.status}
            >
              <MenuItem key={1} value={POND_STATUS_CYCLE.PREPARANDO}>{POND_STATUS_CYCLE.PREPARANDO}</MenuItem>
              <MenuItem key={2} value={POND_STATUS_CYCLE.CULTIVANDO}>{POND_STATUS_CYCLE.CULTIVANDO}</MenuItem>
              <MenuItem key={3} value={POND_STATUS_CYCLE.DESPESCADO}>{POND_STATUS_CYCLE.DESPESCADO}</MenuItem>
              <MenuItem key={4} value={POND_STATUS_CYCLE.TRANSFERIDO}>{POND_STATUS_CYCLE.TRANSFERIDO}</MenuItem>
              <MenuItem key={5} value={POND_STATUS_CYCLE.CONCLUIDO}>{POND_STATUS_CYCLE.CONCLUIDO}</MenuItem>
            </TextField>
          </FormGroup>
        </Grid>
        )}
        <Grid item xs={12}>
          <FormGroup>
            <TextField
              InputLabelProps={{ style: { pointerEvents: 'auto' } }}
              id="observation"
              label="Observações (Opcional)"
              variant="outlined"
              name="observation"
              type="text"
              value={formik.values.observation || ''}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              multiline
              error={formik.touched.observation && formik.errors.observation}
              helperText={
                  formik.touched.observation && formik.errors.observation
                }
            />
          </FormGroup>
        </Grid>
      </Grid>
    </Grid>
  );
}
export { CycleInfo };
